import { useState } from "react";

import StatusLog from "../../../../pages/worklists/genericAuthStatusLayout/components/statusLog";
import { PencilIcon } from "../../../../svg/pencil-Icon";
import SideModal from "../../../modals/filterModal/filterModal";

interface SideModalIconCellProps {
  value: { id: string };
  onSideModalClose?: () => void;
}
export const SideModalIconCell = (props: SideModalIconCellProps) => {
  const { id } = props.value;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleIconClick = async () => {
    setIsModalOpen(true);
  };

  return (
    <div
      className="mt-[3px] flex items-center justify-center"
      onClick={(e) => {
        e.stopPropagation();
        handleIconClick();
      }}
    >
      <PencilIcon />
      {isModalOpen && (
        <SideModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          width="35%"
          children={
            <StatusLog
              onClose={() => {
                setIsModalOpen(false);
              }}
              orderId={id}
              onSideModalClose={props.onSideModalClose}
            />
          }
        />
      )}
    </div>
  );
};
